import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../modules/CProfile';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import MultiSelecter from '../../../components/Multiselect/MultiSelecter';
import Select from 'react-select';
import { Editor } from '@tinymce/tinymce-react';
import Dropzone from 'react-dropzone';
import config from '../../../config';
import $ from 'jquery';
import Autocomplete from 'react-google-autocomplete';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  getInputProps,
} from 'react-places-autocomplete';
import { fetchCountry, fetchRegions, fetchTimeZones } from '../../AddListings';
import { fetchTimeZoneswithCountryCode, fetchTimeZoneswithStateName } from '../../AddListings';
export class ManageListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errClass: '',
      insuranceCertificate: '',
      businessCertificate: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.handleImg = this.handleImg.bind(this);
    this.handleAttachment = this.handleAttachment.bind(this);
    this.handleLocation = this.handleLocation.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.removeGalleryImage = this.removeGalleryImage.bind(this);
    this.removeGallery = this.removeGallery.bind(this);
    this.handleLocationSelect = this.handleLocationSelect.bind(this);
    this.galleryImageMessages = this.galleryImageMessages.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  handleChange(e) {
    let { listing_data } = this.props.selectState;
    listing_data[e.target.name] = e.target.value;
    this.props.setManageListingData(listing_data);
  }

  async componentDidMount() {
    // this.listing_data[gallery_images]=[]
    // await this.props.setManageListingData(this.listing_data)
    const { listing_data } = this.props.selectState;
    // console.log("listing_data",listing_data)
    const { dispatch } = this.props.data;
    dispatch(fetchCountry());
    dispatch(fetchTimeZones())
    dispatch(fetchRegions(listing_data.country_id));

    this.handleLoaded();
  }


  handleLoaded() {
    // Load the Google Maps script if it's not already available
    //  if (!window.google) {
    const script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyDsKhasKdWg0EAsycG_0u0Z5pVAkAGXl7c&libraries=places';
    script.async = true;  // Ensure it loads asynchronously
    script.defer = true;  // Ensure it doesn't block other resources
    script.onload = () => {
      this.setState({ googleAPIReady: true });
    };
    script.onerror = () => {
      console.error('Error loading Google Maps API');
    };
    document.body.appendChild(script);
    // } else {
    //   // If API is already available, just set the flag
    //   this.setState({ googleAPIReady: true });
    // }
  }
  handleLocation(value) {
    let { listing_data } = this.props.selectState;
    listing_data['location'] = value;
    listing_data['lattitude'] = null;
    listing_data['longitude'] = null;
    this.props.setManageListingData(listing_data);
  }

  async handleLocationSelect(address) {
    let { listing_data } = this.props.selectState;
    const results = await geocodeByAddress(address);
    const latLng = await getLatLng(results[0]);
    listing_data['lattitude'] = latLng.lat;
    listing_data['longitude'] = latLng.lng;
    listing_data['location'] = address;
    // const addressName = address.formatted_address;
    // const lng = address.geometry.location.lng();
    // const lat = address.geometry.location.lat();
    // listing_data['lattitude'] = lat;
    // listing_data['longitude'] = lng;
    // listing_data['location'] = addressName;
    this.props.setManageListingData(listing_data);
  }

  handleEditorChange(value) {
    let { listing_data } = this.props.selectState;
    listing_data['description'] = value;
    this.props.setManageListingData(listing_data);
  }

  handleSelect(selected, event) {
    let { listing_data } = this.props.selectState;

    const { dispatch } = this.props.data;
    if (event.name == "country_id") {
      // listing_data['timezone'] = 'select';
      listing_data['listing_region'] = '';
    }
    if (event.name === "listing_region") {
      // listing_data['timezone'] = 'select';
    }

    if (event.name === 'country_id') {
      dispatch(fetchRegions(selected.value));
      if (selected.iso) {
        dispatch(fetchTimeZoneswithCountryCode(selected.iso, this.updatetTimezone.bind(this)));
      }
    } else if (event.name === "listing_region") {
      dispatch(fetchTimeZoneswithStateName(selected.label,this.updatetTimezoneWithStateName.bind(this)));
    }


    listing_data[event.name] = selected.value;
    this.props.setManageListingData(listing_data);
  }

  updatetTimezone = (selected) => {
    let { listing_data } = this.props.selectState;
    console.log("selectedTime", selected)
    listing_data['timezone'] = selected ? selected : 'select';

    this.props.setManageListingData(listing_data);
  }
  updatetTimezoneWithStateName = (selected) => {
    let { listing_data } = this.props.selectState;

    if (selected) {
      listing_data['timezone'] = selected;
      this.props.setManageListingData(listing_data);
    }
  }

  handleMultiSelect = async (id, selectedList) => {
    let { listing_data } = this.props.selectState;
    let arr = [];
    selectedList.map((item) => arr.push(item.id));
    listing_data[id] = arr;
    this.props.setManageListingData(listing_data);
  };

  removeGallery(id) {
    if (window.confirm('Are you Sure?')) {
      this.props.removeGalleryImage(id);
    }
  }

  galleryImageMessages() {
    this.props.setAlertMessage({
      message: 'Please upload atleast 1 gallery Image before remove.',
      color: 'teal',
    });
    this.setState({ errClass: 'website' });
    setTimeout(() => {
      this.props.setAlertMessage({
        message: '',
        color: '',
      });
      this.setState({ errClass: '' });
    }, 5000);
  }

  removeGalleryImage(img) {
    let {
      listing_data: { gallery_images },
      listing_data,
    } = this.props.selectState;

    gallery_images = gallery_images.filter((i) => i !== img);
    listing_data['gallery_images'] = gallery_images;
    this.props.setManageListingData(listing_data);
  }

  async handleImg(event) {
    let name = event.target.name;
    let { files } = event.target;
    let { listing_data } = this.props.selectState;
    if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
      $("input[name='" + name + "']").val('');
      this.props.setAlertMessage({
        message: 'The Image type must be JPEG, JPG, PNG.',
        color: 'teal',
      });

      listing_data[name] = null;
      this.props.setManageListingData(listing_data);
    } else if (files[0].size > 8000000) {
      $("input[name='" + name + "']").val('');
      this.props.setAlertMessage({
        message: 'The Image size must be less than 8 MB.',
        color: 'teal',
      });

      listing_data[name] = null;
      this.props.setManageListingData(listing_data);

      //---> Disappearing the Alert Message after 3 sec
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        listing_data[name] = e.target.result;
        this.props.setManageListingData(listing_data);
        this.props.showCoverPreview(true);
      };
    }
    setTimeout(() => {
      this.props.setAlertMessage({
        message: '',
        color: '',
      });
    }, 5000);
  }

  async handleAttachment(event) {
    let name = event.target.name;
    let { files } = event.target;
    let { listing_data } = this.props.selectState;
    if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
      if (files[0].name.match(/\.(pdf|PDF|docx|DOCX|doc|DOC)$/)) {
        console.log('not good');
        if (files[0].size > 8000000) {
          $("input[name='" + name + "']").val('');
          this.props.setSiteAlertMessage({
            message: 'File size must be less than 8 MB',
            color: 'teal',
          });
          listing_data[name] = null;
          this.props.setManageListingData(listing_data);
          //---> Disappearing the Alert Message after 3 sec
        } else {
          if (name == 'insurance_certificate') {
            this.setState({ insuranceCertificate: event.target.files[0] });
          } else {
            this.setState({ businessCertificate: event.target.files[0] });
          }
          let reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = (e) => {
            listing_data[name] = e.target.result;
            this.props.setManageListingData(listing_data);
            this.props.showCoverPreview(true);
          };
        }
      }
    } else {
      this.props.setSiteAlertMessage({
        message: 'Only select pdf || PDF || docx || DOCX || doc || DOC files',
        color: 'teal',
      });
    }
    setTimeout(() => {
      this.props.setAlertMessage({
        message: '',
        color: '',
      });
    }, 5000);
  }

  onDrop = (files) => {
    let {
      listing_data: { gallery, gallery_images },
      listing_data,
    } = this.props.selectState;
    // let img_arr=[];
    if (files.length + gallery.length + gallery_images.length > 6) {
      this.props.setAlertMessage({
        message: 'You can only select 6 images.',
        color: 'teal',
      });
    } else {
      Object.keys(files).map(async (item, i) => {
        if (!files[item].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
          this.props.setAlertMessage({
            message: 'The Image type must be JPEG, JPG, PNG',
            color: 'teal',
          });
        } else if (files[item].size > 8000000) {
          this.props.setAlertMessage({
            message: 'Image size should not be more than 8 MB.',
            color: 'teal',
          });
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(files[item]);
          reader.onload = (e) => {
            if (!gallery_images.includes(e.target.result)) {
              gallery_images.push(e.target.result);
            }
          };
        }
      });
      listing_data['gallery_images'] = gallery_images;
      this.props.setManageListingData(listing_data);
    }
    setTimeout(() => {
      this.props.setAlertMessage({
        message: '',
        color: '',
      });
    }, 5000);
  };

  submitHandler(e) {
    e.preventDefault();
    let { listing_data } = this.props.selectState;
    let specials = /[!@#$%`^&*()_+\-=\[\]{};':"\\|,~<>\/?]+/;
    let locationRegex = /[!@#$%`^&*()_+\=\[\]{};:\\|~<>\?]+/;
    let urlRegex =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    if (specials.test(listing_data.listing_name)) {
      this.props.setAlertMessage({
        message: 'Listing name should not contain special characters',
        color: 'teal',
      });
      this.setState({ errClass: 'listing_name' });
    } else if (listing_data.location === '') {
      this.props.setAlertMessage({
        message: 'Please enter the Location',
        color: 'teal',
      });
      this.setState({ errClass: 'location' });
    } else if (
      locationRegex.test(listing_data.location) ||
      listing_data.lattitude === null
    ) {
      this.props.setAlertMessage({
        message:
          listing_data.lattitude === null
            ? 'Please select the valid location from the list.'
            : 'Please enter the valid Location',
        color: 'teal',
      });
      this.setState({ errClass: 'location' });
    } else if (listing_data.description === '') {
      this.props.setAlertMessage({
        message: 'Please enter the Description',
        color: 'teal',
      });
      this.setState({ errClass: 'desc' });
    } else if (listing_data.listing_category === 'select') {
      this.props.setAlertMessage({
        message: 'Please select the Category',
        color: 'teal',
      });
      this.setState({ errClass: 'category' });
    } else if (listing_data.listing_region === '') {
      this.props.setAlertMessage({
        message: 'Please select the region.',
        color: 'teal',
      });
      this.setState({ errClass: 'region' });
    } else if (
      listing_data.gallery_images.length + listing_data.gallery.length ===
      0
    ) {
      this.props.setAlertMessage({
        message: 'Please upload atleast 1 gallery Image',
        color: 'teal',
      });
      this.setState({ errClass: 'website' });
    } else if (
      listing_data.video_url &&
      !listing_data.video_url.match(urlRegex)
    ) {
      this.props.setAlertMessage({
        message: 'Please enter the valid video URL',
        color: 'teal',
      });
      this.setState({ errClass: 'video_url' });
    } else {
      let { insuranceCertificate, businessCertificate } = this.state;
      listing_data.insuranceCertificate = insuranceCertificate;
      listing_data.businessCertificate = businessCertificate;
      this.props.updateListing({ ...listing_data });
    }
    setTimeout(() => {
      this.props.setAlertMessage({
        message: '',
        color: '',
      });
      this.setState({ errClass: '' });
    }, 5000);
  }

  render() {
    const { errClass } = this.state;
    const { listing_data } = this.props.selectState;
    // const  { country, regions } = this.props.data.AddListingState;
    const { listing_lables, listing_categories, listingSpinner, cover_change } = this.props.CProfileState;
    // const { timeZoneList, country, stateTimeZoneList, countryTimeZoneList, regions } = this.props.AddListingState;
    const { timeZoneList, country, stateTimeZoneList, countryTimeZoneList, regions } = this.props.data.AddListingState;
    let ZoneList = [];
    console.log("listing_data_render", listing_data)
    if (listing_data && listing_data.listing_region &&  listing_data.country_id) {
      ZoneList = stateTimeZoneList.length > 0 ? stateTimeZoneList : (countryTimeZoneList.length > 0) ? countryTimeZoneList : timeZoneList
      if (stateTimeZoneList.length > 0) {
        ZoneList = stateTimeZoneList;
      } else if (countryTimeZoneList.length > 0) {
        ZoneList = countryTimeZoneList;
      } else {
        ZoneList = timeZoneList
      }
    } else {
      ZoneList = []
    }
    console.log('listing_data', this.props.data.AddListingState)
    // const { country, regions } = this.props.data.AddListingState;
    return (
      <Fragment>
        {/* -----------------------Manage Listing section---------------------- */}
        <div id="tabs-2">
          {listing_data && (
            <form
              className="profile_form update-listing--form"
              onSubmit={this.submitHandler}
            >
              <div className="form-item">
                <label>Listing Name:</label>
                <input
                  className={errClass == 'listing_name' ? 'border-red-500' : ''}
                  placeholder="Your Listing Name"
                  type="text"
                  name="listing_name"
                  onChange={this.handleChange}
                  defaultValue={listing_data.listing_name}
                />
              </div>
              <div className="form-item">
                <label> Location:</label>
                <PlacesAutocomplete
                  value={listing_data.location}
                  onChange={this.handleLocation}
                  onSelect={this.handleLocationSelect}
                  searchOptions={{
                    // componentRestrictions:{
                    //   country:'US'
                    // }
                  }}
                >
                  {({
                    getInputProps,
                    getSuggestionItemProps,
                    suggestions,
                    loading,
                  }) => {
                    return (
                      <div className="autocomplete-root">
                        <input
                          {...getInputProps({
                            placeholder: 'Enter the location',
                            className: 'location-search-input border-blue-800',
                          })}
                        />

                        <div className="autocomplete-dropdown-container">
                          {loading && <div>Loading...</div>}
                          {suggestions.map((suggestion, i) => {
                            const className = suggestion.active
                              ? 'suggestion-item--active'
                              : 'suggestion-item';
                            // inline style for demonstration purpose
                            const style = suggestion.active
                              ? {
                                backgroundColor: '#fafafa',
                                cursor: 'pointer',
                              }
                              : {
                                backgroundColor: '#ffffff',
                                cursor: 'pointer',
                              };
                            return (
                              <div
                                key={i}
                                {...getSuggestionItemProps(suggestion, {
                                  className,
                                  style,
                                })}
                              >
                                <span key={suggestion}>
                                  {suggestion.description}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }}
                </PlacesAutocomplete>
                {/* <Autocomplete
                        apiKey={config.__GOOGLE_MAP_KEY__}
                        style={{ width: "90%" }}
                        onPlaceSelected={(place) => {
                          this.handleLocationSelect(place)
                        }}
                        options={{
                          types: ["(regions)"],
                        }}
                        value={listing_data.location}
                        onChange={(e)=>this.handleLocation(e.target.value)}
                    />*/}
              </div>
              {/*<div className="form-item">
                <label>Contact Email/URL :</label>
                <input
                  className={
                    errClass == "contact_email_or_url" ? "border-red-500" : ""
                  }
                  placeholder="Contact email address"
                  type="text"
                  name="contact_email_or_url"
                  onChange={this.handleChange}
                  defaultValue={listing_data.contact_email_or_url}
                />
                </div>*/}
              <div className="form-item">
                <label>Description: </label>

                <Editor
                  apiKey="x84ab9bfprazeycxveeoxsrl7rbgmv5887mhpwjieitv0v9u"
                  value={listing_data.description}
                  name="description"
                  init={{
                    height: 400,
                    //menubar: 'insert',
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste imagetools wordcount',
                    ],
                    toolbar:
                      'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                  }}
                  onEditorChange={this.handleEditorChange}
                />
              </div>
              <div className="form-item">
                <label>Listing Category:</label>

                <Select
                  name={'listing_category'}
                  className="new_select"
                  options={listing_categories}
                  value={listing_categories.filter((option) => {
                    return option.value === listing_data.listing_category;
                  })}
                  onChange={this.handleSelect}
                  searchable={true}
                />
              </div>
              <div className="form-item">
                <label>Listing Country:</label>
                <Select
                  name={'country_id'}
                  className="new_select"
                  options={country}
                  value={country.filter(
                    (option) => option.value === listing_data.country_id
                  )}
                  onChange={this.handleSelect}
                  searchable={true}
                />
              </div>

              <div className="form-item">
                <label>Listing Region:</label>
                <Select
                  name={'listing_region'}
                  className="new_select"
                  options={regions}
                  value={regions.filter((option) => {
                    return option.value === listing_data.listing_region;
                  })}
                  onChange={this.handleSelect}
                  searchable={true}
                />
              </div>
              <div className="form-item">
                <label>Time Zone</label>

                <Select
                  name={'timezone'}
                  className="new_select"
                  options={ZoneList}
                  value={ZoneList.filter((option) => {
                    return (
                      option.value == listing_data.timezone
                    );
                  })}
                  onChange={this.handleSelect}
                  searchable={true}
                />
              </div>
              <div className="form-item multiSelect">
                <label>Listing Lables (optional) :</label>
                <MultiSelecter
                  id="listing_label"
                  Options={listing_lables}
                  displayValue={'label_name'}
                  selectedValue={listing_data.multilabel}
                  fireData={(id, selectedList) =>
                    this.handleMultiSelect(id, selectedList)
                  }
                />
              </div>

              <div className="form-item file_upload-field">
                <label>Cover Image:</label>
                <input
                  name="cover_image"
                  type="file"
                  onChange={this.handleImg}
                />
                <div className="file_desc">
                  <p>Maximum file size: 8 MB.</p>
                </div>
              </div>
              {cover_change ? (
                <img
                  key={listing_data.cover_image}
                  className="md:ml-48 max-w-sm my-5"
                  src={listing_data.cover_image}
                />
              ) : (
                <img
                  key={listing_data.cover_img}
                  className="md:max-w-sm my-5 ml-13rem"
                  src={config.__IMG_URL__ + listing_data.cover_img}
                />
              )}
              <div className="form-item file_upload-field ">
                <label>Gallery images:</label>
                <Dropzone onDrop={this.onDrop} maxFiles={10}>
                  {({ getRootProps, getInputProps }) => (
                    <section className="container">
                      <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <p>
                          Drag 'n' drop some files here, or click to select
                          files
                        </p>
                      </div>
                    </section>
                  )}
                </Dropzone>
              </div>
              <div className="manage_listing__gallery flex">
                <ul className="gallery__images flex">
                  {listing_data &&
                    listing_data.gallery &&
                    listing_data.gallery.length > 0 &&
                    listing_data.gallery.map((img) => (
                      <li
                        className="mx-3 image-area mb-8"
                        key={img.id}
                        id={'image-' + img.id}
                      >
                        <a
                          className="remove-image"
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            listing_data.gallery_images &&
                              listing_data.gallery_images.length +
                              listing_data.gallery.length >
                              1
                              ? this.removeGallery(img.id)
                              : this.galleryImageMessages()
                          }
                        >
                          &#215;
                        </a>
                        <img
                          key={img.id}
                          src={config.__IMG_URL__ + img.gallery_img}
                        />
                      </li>
                    ))}
                  {listing_data &&
                    listing_data.gallery_images &&
                    listing_data.gallery_images.length > 0 &&
                    listing_data.gallery_images.map((img, i) => (
                      <li className="mx-2 image-area" key={i}>
                        <Link
                          to="#"
                          className="remove-image"
                          onClick={() => this.removeGalleryImage(img)}
                        >
                          &#215;
                        </Link>
                        <img key={img} src={img} />
                      </li>
                    ))}
                </ul>
              </div>

              {/*<div className="form-item">
                <label>Website : (Optional)</label>
                <input
                  onChange={this.handleChange}
                  defaultValue={listing_data.website}
                  type="text"
                  name="website"
                  placeholder="website url"
                  autoComplete="off"
                  className={
                    errClass == "website" ? "border-red-500" : "border-blue-800"
                  }
                />
              </div>
              <div className="form-item">
                <label>Phone Number: (Optional)</label>
                <input
                  onChange={this.handleChange}
                  defaultValue={listing_data.phone}
                  type="text"
                  name="phone"
                  placeholder="Phone no."
                  autoComplete="off"
                  className={
                    errClass == "phone" ? "border-red-500" : "border-blue-800"
                  }
                />
              </div>*/}

              <div className="form-item">
                <label>Video : (optional)</label>
                <input
                  className={
                    errClass == 'video_url'
                      ? 'border-red-500'
                      : 'border-blue-800'
                  }
                  type="text"
                  name="video_url"
                  placeholder="Url to video"
                  autoComplete="off"
                  defaultValue={listing_data.video_url}
                  onChange={this.handleChange}
                />
              </div>
              <div className="form-item file_upload-field">
                <label>Insurance Certificate (optional) </label>
                <input
                  name="insurance_certificate"
                  type="file"
                  onChange={this.handleAttachment}
                />
                <div className="file_desc">
                  <p>Maximum file size: 8 MB.</p>
                </div>
              </div>
              {/* {listing_data.insurance_certificate && (
                <a
                  href={
                    config.__IMG_URL__ +
                    'uploads/' +
                    listing_data.insurance_certificate
                  }
                  target="_blank"
                  className="text_nav_blue"
                >
                  {listing_data.insurance_certificate}
                </a>
              )} */}
              <div className="form-item file_upload-field">
                <label>Business Certificate (optional)</label>
                <input
                  name="business_certificate"
                  type="file"
                  onChange={this.handleAttachment}
                />
                <div className="file_desc">
                  <p>Maximum file size: 8 MB.</p>
                </div>
              </div>
              {/* {listing_data.business_certificate && (
                <a
                  href={
                    config.__IMG_URL__ +
                    'uploads/' +
                    listing_data.business_certificate
                  }
                  target="_blank"
                  className="text_nav_blue"
                >
                  {listing_data.business_certificate}
                </a>
              )} */}
              <div className="form-grid left-center">
                <div className="form-actions">
                  <button type="submit">
                    {listingSpinner ? <LoadingSpinner /> : 'Update'}
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectState: state.selectState,
  CProfileState: state.CProfileState,
});

export default connect(mapStateToProps, actions)(ManageListing);



// WEBPACK FOOTER //
// ./src/routes/CProfile/components/ManageListing.js